<template>
  <div class="row" style="margin-top: 20px">
    <div class="col-xl-4 col-lg-6 col-md-6" v-for="(ticket, index) in tickets" :key="index" style="margin-top: -20px">
      <ticket-card
        :ticket="ticket"
        :employee="getName(ticket['employee_id_from'])"
        :employee_id="getEmployeeId"
        @update = "update">
      </ticket-card>
    </div>
  </div>
</template>

<script>
    import {getCookie} from "../../plugins/axios";
    import TicketCard from "./TicketCard";

    export default {
      name: "tickets-list",
      components: {TicketCard},
      props:["employees", "tickets"],
      methods:{
        getName(id){
          const employee = this.employees.filter(employee => employee['employee_id'] === id);
          return employee[0]['first_name'] + " " + employee[0]['last_name'];
        },
        update(data, action){
          this.$emit("update", data, action);
        },
      },
      computed:{
        getEmployeeId(){
          return getCookie('Employee-id');
        },
      },
    }
</script>

<style scoped>

</style>
